<!--
	DistanceUnitRadios.svelte
-->

<script>
    import Radio from '@smui/radio';
    export let selectedValue;       // bound to $searchFilters.distanceUnit
</script>

<style>
    .radio-group {
        /* border: 1px solid red; */
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="radio-group flex-center jc-start">
    <Radio
        bind:group={selectedValue}
        value={"mi"}
    />
    miles
    <div class="spacer-w-15"></div>
    <Radio
        bind:group={selectedValue}
        value={"km"}
    />
    km
</div>
